module.exports = __webpack_public_path__ + "img/no-time-entries.71e0c606.png";